// Module
var code = "<sb-app-checklist-viewer id=\"angular-checklist-viewer\"></sb-app-checklist-viewer> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/deliverables/sbDeliverableChecklists/panels/sbChecklistDetailsPanel/checklist_details_panel.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;